module.exports = __webpack_public_path__ + "img/mountain-mobile.0437bbe2.png";